import { HostContext } from '../embed-script/HostContext';
import { store } from '../redux/app/store';
import { setHostContext } from '../redux/features/hostContext/hostContextSlice';

const CTX_KEY_EMBEDDED = 'em_hostContext';
const CTX_KEY_STANDALONE = 'sa_hostContext_2510170927'; // Increment suffix if changes to expected hostcontext format is needed in back- or frontend to give all users a clean slate

const _storage = (isEmbedded: boolean) => {
    return {
        underlying: isEmbedded ? sessionStorage : localStorage,
        key: isEmbedded ? CTX_KEY_EMBEDDED : CTX_KEY_STANDALONE,
    };
};

export const hostContextStorage = {
    save(hostContext: HostContext, isEmbedded: boolean): void {
        const storage = _storage(isEmbedded);

        // Warning if trying to save context without an id
        if (!hostContext.id) {
            console.warn('hostContextStorage.save: Attempting to save hostContext without id', {
                isEmbedded,
                context: hostContext,
                storageKey: storage.key,
            });
        }

        storage.underlying.setItem(storage.key, JSON.stringify(hostContext));
        store.dispatch(setHostContext(hostContext));
    },
    load(isEmbedded: boolean): HostContext | undefined {
        const hostContextString = this.loadS(isEmbedded);
        if (hostContextString) {
            try {
                return JSON.parse(hostContextString) as HostContext;
            } catch (error) {
                console.error('Failed to parse hostContext', error);
            }
        }
        return undefined;
    },
    loadS(isEmbedded: boolean): string | null {
        const storage = _storage(isEmbedded);
        return storage.underlying.getItem(storage.key);
    },
    clear(isEmbedded: boolean): void {
        const storage = _storage(isEmbedded);
        storage.underlying.removeItem(storage.key);
        store.dispatch(setHostContext({}));
    },
    // Factory function
    forMode(isEmbedded: boolean) {
        return {
            save: (hostContext: HostContext) => {
                hostContextStorage.save(hostContext, isEmbedded);
            },
            load: () => hostContextStorage.load(isEmbedded),
            loadS: () => hostContextStorage.loadS(isEmbedded),
            clear: () => {
                hostContextStorage.clear(isEmbedded);
            },
        };
    },
    autoMode() {
        const isEmbedded =
            new URLSearchParams(window.location.search).get('embedded') === 'true' || window.self !== window.top;
        return {
            save: (hostContext: HostContext) => {
                hostContextStorage.save(hostContext, isEmbedded);
            },
            load: () => hostContextStorage.load(isEmbedded),
            loadS: () => hostContextStorage.loadS(isEmbedded),
            clear: () => {
                hostContextStorage.clear(isEmbedded);
            },
        };
    },
};
